import { BaseModel } from "@/models/base.model"
import type { IProductionStatementCustomerPurchaseOrder } from "@/interfaces/api/production-statement-customer-purchase-order.interface"

export class ProductionStatementCustomerPurchaseOrder
  extends BaseModel
  implements IProductionStatementCustomerPurchaseOrder
{
  public static className = "ProductionStatementCustomerPurchaseOrder"
  public static verboseName = "Productieverantwoording-inkooporder klant"

  productionStatement: string
  customerPurchaseOrder: string
  amount: string
  comment: string

  constructor(allocation: IProductionStatementCustomerPurchaseOrder) {
    super(allocation)

    this.productionStatement = allocation.productionStatement
    this.customerPurchaseOrder = allocation.customerPurchaseOrder
    this.amount = allocation.amount
    this.comment = allocation.comment ?? ""
  }
}
